var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "header header-menu-section", class: _vm.toggleclass },
    [
      _c("page-header-search"),
      _vm._v(" "),
      _c("div", { staticClass: "menu-container" }, [
        _c(
          "div",
          { staticClass: "secondary-region" },
          [
            _c(
              "b-container",
              [
                _c(
                  "b-navbar",
                  { attrs: { toggleable: "lg" } },
                  [
                    _c(_vm.elementLogoComponent, {
                      tag: "commponent",
                      attrs: { logo: _vm.logoFile },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header-navigation-region" },
                      [
                        _c(
                          "div",
                          { staticClass: "mini-main-navigation" },
                          [
                            _c(
                              "b-collapse",
                              { attrs: { id: "nav_collapse", "is-nav": "" } },
                              [
                                _c("main-menu", {
                                  attrs: { "menu-style": "desktop" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-actions" },
                          [
                            _c("user-actions", {
                              attrs: { "help-active": _vm.helpActive },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(_vm.mobilenav, { tag: "component" }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }